import { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Grid,
  Typography,
  CircularProgress,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  logIn,
  requestPasswordReset,
} from "../redux/slices/authenticationSlice";
import { useTranslation } from "react-i18next";
import ForgotPassword from "../components/ForgotPassword";
import { Box, Stack } from "@mui/system";
import { Link } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import colaBg2 from "../assets/cc-logo-3.png";

const LoginPage = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showForgotPassword, setShowForgotPassword] = useState();

  const requestPasswordResetLoading = useSelector(
    (state) => state.authentication.requestPasswordResetLoading
  );
  const userLogInError = useSelector(
    (state) => state.authentication.userLogInError
  );
  const userLogInLoading = useSelector(
    (state) => state.authentication.userLogInLoading
  );

  useEffect(() => {
    if (requestPasswordResetLoading === "SUCCESS") {
      setShowForgotPassword(false);
    }
  }, [requestPasswordResetLoading]);

  const handleUsernameChange = (event) => {
    setUsername(event.target.value);
  };
  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
  };
  const loginUser = () => {
    const usernameValue = username;
    const passwordValue = password;
    dispatch(logIn({ usernameValue, passwordValue }))
      .then((response) => {
        if (response.error?.message) {
          return;
        } else {
          login(response.payload.attributes);
        }
      })
      .catch((err) => alert(err));
  };
  const onShowPassword = () => {
    setShowForgotPassword(true);
  };
  const onCancelForgotPassword = () => {
    setShowForgotPassword(false);
  };
  const onConfirmForgotPassword = (email) => {
    dispatch(requestPasswordReset(email));
  };

  return (
    <div
      style={{
        background: `url(${colaBg2}) no-repeat center bottom`,
        backgroundSize: "cover",
        height: "100vh",
        maxWidth: "800px",
        margin: "auto",
      }}
    >
      <div
        style={{
          maxWidth: "500px",
          padding: "12px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "80%",
          margin: "auto",
        }}
      >
        <div className="companyName">{t("companyName")}</div>
        {showForgotPassword ? (
          <ForgotPassword
            onCancelForgotPassword={onCancelForgotPassword}
            onConfirmForgotPassword={onConfirmForgotPassword}
          />
        ) : (
          <>
            <form
              onSubmit={handleSubmit}
              style={{ backgroundColor: "#ffffffc2", borderRadius: "5%" }}
            >
              <Grid container spacing={2} padding="12px" marginTop="16px">
                <Grid item xs={12}>
                  <TextField
                    id="username"
                    label={t("login.username")}
                    value={username}
                    onChange={handleUsernameChange}
                    fullWidth
                    required
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="password"
                    label={t("login.password")}
                    type="password"
                    value={password}
                    onChange={handlePasswordChange}
                    fullWidth
                    required
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                {requestPasswordResetLoading === "SUCCESS" && (
                  <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    margin="8px 0"
                  >
                    <Typography
                      variant="caption"
                      align="right"
                      color="success.main"
                    >
                      {t("login.forgotPasswordMessageSuccess")}
                    </Typography>
                  </Grid>
                )}
                {userLogInError && (
                  <Grid
                    container
                    direction="row"
                    justifyContent="end"
                    margin="8px 0"
                  >
                    <Typography variant="body" align="right" color="error">
                      {t("errors." + userLogInError.code)}
                    </Typography>
                  </Grid>
                )}
                <Grid
                  container
                  direction="row"
                  justifyContent="end"
                  margin="8px 0"
                >
                  <Link onClick={onShowPassword}>
                    <Typography variant="body" align="right">
                      {t("login.forgotPassword")}
                    </Typography>
                  </Link>
                </Grid>

                <Grid item xs={12}>
                  <Button
                    disabled={
                      !username || !password || userLogInLoading === "PENDING"
                    }
                    variant="contained"
                    color="error"
                    type="submit"
                    fullWidth
                    onClick={loginUser}
                  >
                    {userLogInLoading === "PENDING" ? (
                      <Box sx={{ display: "flex" }}>
                        <CircularProgress color="inherit" />
                      </Box>
                    ) : (
                      t("login.login")
                    )}
                  </Button>
                </Grid>
              </Grid>
            </form>
            <Stack
              direction="column"
              justifyContent="center"
              alignItems="center"
              marginTop="12px"
            >
              <Typography color="white">
                {t("login.noAccountWording")}
              </Typography>
              <Link style={{ color: "#FFFFFF" }} to="/sign-up">
                {t("login.registerHere")}
              </Link>
            </Stack>
            {/* <Box
              component="div"
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "30vh",
              }}
            >
              <Container
                sx={{
                  width: "200px",
                  height: "100px",
                  borderRadius: "10%",
                  background: "#FFFFFF",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img src={ccLogo} alt="logo" width="150px" />
              </Container>
            </Box> */}
          </>
        )}
      </div>
    </div>
  );
};

export default LoginPage;
